const FILTERS_STORAGE_KEY = 'pma-hac-filters';

const DEFAULT_FILTERS = {
  name: '',
  phone: '',
  pma_type: '1',
  country: '',
  retailer: '',
  pma: '',
};

const EMPTY_FILTERS = {
  ...DEFAULT_FILTERS,
  pma_type: '',
};

const FILTER_GRID = {
  name: { xs: 12, sm: 6, md: 3 },
  standard: { xs: 12, sm: 6, md: 2 },
  retailer: { xs: 12, sm: 6, md: 3 },
  action: { xs: 12, sm: 6, md: 2 },
  reset: { xs: 12, sm: 6, md: 3 },
};

const SORT_FIELDS = {
  NAME: 'name',
  LAST_NAME: 'last_name',
  RETAILER: 'retailer_name',
  PMA_TYPE: 'pma_type',
  LAST_UPDATE: 'last_update',
};

export {
  DEFAULT_FILTERS,
  EMPTY_FILTERS,
  FILTER_GRID,
  FILTERS_STORAGE_KEY,
  SORT_FIELDS,
};
